/**
 * Модуль ajax отправки форм
 *
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2017 delphinpro
 * @license     licensed under the MIT license
 */

export default function(target, options) {
  let fetchOptions = {
    method: 'POST',
    ...options,
  };

  target = target.replace(/^#/, '');

  return fetch(target, fetchOptions)

      .then((response) => {
        if (!target) {
          throw new Error('Invalid url');
        }

        if (response.ok) {
          return response.json();
        }

        throw new Error(`${response.status} ${response.statusText}`);
      })

      .then((json) => {
        if (json['statusOk']) {
          return json;
        }

        throw new Error(json['message'] || 'Server response was not ok');
      });
}



// WEBPACK FOOTER //
// ./source/js/components/sendAjax.js